import { Component, OnInit, Input } from '@angular/core';
import { INextgenApplicationModel, NextgenApplicationModel } from '../../../../../models/child-application/nextgen-application.model';
import { DashboardHelper } from '../../../../../services/dashboard.service';
import { Router } from '@angular/router';
import { BaseComponent } from '../../../../base/base.component';
import { SafeResourceUrl } from '@angular/platform-browser';
import { isFranklyProductType } from '../../../../../modules/catch-core/data/helpers/product-type.helper';
import { ProjectStore } from '../../../../../services/stores/projects.store';
import { MaterialModule } from '../../../../../modules/catch-core/third-party/material/material.module';

@Component({
  selector: 'app-toolbar-app-menu-icon',
  templateUrl: './toolbar-app-menu-icon.component.html',
  styleUrls: ['./toolbar-app-menu-icon.component.css'],
  standalone: false,
})
export class ToolbarAppMenuIconComponent extends BaseComponent implements OnInit {
  @Input() iconSource: string = '';
  @Input() base64String: SafeResourceUrl = '';
  @Input() labelText: string = '';
  @Input() appModel: INextgenApplicationModel = {} as INextgenApplicationModel;

  constructor(
    private dashboardHelper: DashboardHelper,
    private projectStore: ProjectStore,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {}

  onAppIconClick() {
    if (this.labelText === 'catch hub') {
      this.loadNavigation();
    } else {
      if (this.appModel?.productType?.toLocaleLowerCase() !== 'other') {
        if (isFranklyProductType(this.appModel.productType)) {
          this.projectStore.loadInitialData();
        }
        this.setCurrentAnimal(this.appModel);
      }
      if (this.appModel && this.appModel.url !== '') {
        this.dashboardHelper.setShowRightPanel(false);
        this.dashboardHelper.setShowLeftSidePanel(false);
        this.dashboardHelper.loadApplication(this.appModel);
      }
    }
  }

  private loadNavigation(): void {
    this.dashboardHelper.setSelectedItem('home');
    this.dashboardHelper.setShowRightPanel(false);
    this.dashboardHelper.setShowLeftSidePanel(false);
    //this.dashboardHelper.setCurrentApplication('catch hub');
    this.router.navigate(
      [
        '/',
        'dashboard',
        {
          outlets: {
            mainPanel: ['products'],
            leftSidePanel: ['blank'],
            tabPanel: ['blank'],
          },
        },
      ],
      { queryParamsHandling: 'preserve' },
    );
  }

  private setCurrentAnimal(loadAnimal: any): void {
    if (!loadAnimal.isExternal) {
      this.dashboardHelper.currentETApplication = loadAnimal;
    }
  }
}
